/**
 * TanStack Query hooks for `igaming-mass-payout-processing`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingMassPayoutProcessingQueryKeys,
	type CreateIgamingMassPayoutProcessingBody,
	type ListIgamingMassPayoutProcessingResponse,
	type IgamingMassPayoutProcessingRow,
} from "./api";

export function useIgamingMassPayoutProcessingList(): UseQueryResult<ListIgamingMassPayoutProcessingResponse, Error> {
	return useQuery({
		queryKey: igamingMassPayoutProcessingQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingMassPayoutProcessingCreate(): UseMutationResult<IgamingMassPayoutProcessingRow, Error, CreateIgamingMassPayoutProcessingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingMassPayoutProcessingQueryKeys.all });
		},
	});
}

export function useIgamingMassPayoutProcessingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingMassPayoutProcessingQueryKeys.all });
		},
	});
}
